import React, { Dispatch, SetStateAction, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { vehicleContext } from '../VehicleProvider';
import {
  Container,
  ContinueButton,
  Legal,
  Title,
  H3,
  Description,
  HeaderImage,
} from './InterstitialModal.styles';

interface InterstitialModalProps {
  setMutate: Dispatch<SetStateAction<boolean>>;
}

const InterstitialModal: React.FC<InterstitialModalProps> = ({ setMutate }) => {
  const { t } = useTranslation();
  const { vehicle } = useContext(vehicleContext);
  const { market } = vehicle ?? {};

  const step1Title =
    market === 'ca'
      ? t(`vehiclePricingBar.interstialModal.step1_title_CA`)
      : t(`vehiclePricingBar.interstialModal.step1_title`);

  const ctaCopy =
    market === 'ca'
      ? t(`vehiclePricingBar.interstialModal.footerButtonText_CA`)
      : t(`vehiclePricingBar.interstialModal.footerButtonText`);

  return (
    <Container>
      <HeaderImage src="https://www.audi.ca/content/dam/nemo/ca/online-buy/1032x610_serviceimage_as_2021_3550.png">
        <span role="img" aria-label={t(`vehiclePricingBar.interstialModal.altText`)} />
      </HeaderImage>
      <Title data-testid="main-heading">{t(`vehiclePricingBar.interstialModal.title`)}</Title>

      <H3>{step1Title}</H3>
      <Description>{t(`vehiclePricingBar.interstialModal.step1_description`)}</Description>

      <H3>{t(`vehiclePricingBar.interstialModal.step2_title`)}</H3>
      <Description>{t(`vehiclePricingBar.interstialModal.step2_description`)}</Description>

      <H3>{t(`vehiclePricingBar.interstialModal.journeyText`)}</H3>

      <ContinueButton
        variant="primary"
        data-testid="continue-button"
        onClick={() => setMutate(true)}
      >
        {ctaCopy}
      </ContinueButton>

      <Legal>
        {t(`vehiclePricingBar.interstialModal.legal`)}
        <a href="www.audiusa.com/myaudi">
          {t(`vehiclePricingBar.interstialModal.legalButtonText`)}
        </a>
      </Legal>
    </Container>
  );
};

export default InterstitialModal;
